import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { useCustomerAuth } from '../context/CustomerAuthContext';
import { LogOut } from 'lucide-react';

const CustomerNav = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { logout } = useCustomerAuth();
  const isActive = (path) => location.pathname === path;

  const linkClass = (path) =>
    `px-4 py-2 rounded-lg text-sm font-medium ${
      isActive(path)
        ? 'bg-indigo-600 text-white'
        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
    }`;

  const handleLogout = () => {
    logout();
    window.location.href = '/customer/login';
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-6 flex items-center justify-between">
      <div className="flex flex-wrap gap-2">
        <Link to="/customer/portal" className={linkClass('/customer/portal')}>
          {t('customer.nav.dashboard')}
        </Link>
        <Link to="/customer/offers" className={linkClass('/customer/offers')}>
          {t('customer.nav.offers')}
        </Link>
      </div>
      <button
        onClick={handleLogout}
        className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg flex items-center gap-2"
      >
        <LogOut className="w-4 h-4" />
        {t('customer.nav.logout')}
      </button>
    </div>
  );
};

export default CustomerNav;
